import React from "react";
import RefreshButton from "./RefreshButton";
import { FixedHeader, PrimaryHeader, SecondaryHeader } from "../../ui/Header";
import ButtonGroup from "../../ui/ButtonGroup/ButtonGroup";
import Button from "../../ui/Button/Button";
import TeaserForm from "../../ui/TeaserForm/TeaserForm";
import ModerRejectReason from "../../ui/ModerRejectReason/ModerRejectReason";
import FormMessage from "../../ui/FormMessage/FormMessage";
import CampaignsSelect from "../../components/CampaignsSelect";
import Loader from "../../ui/Loader/Loader";
import CampaignOverview from "../../ui/CampaignOverview/CampaignOverview";

import formatDate from "../../utils/formatDate";

const TeaserModerationView = ({
  showRefreshButton,
  onRefreshClick,
  showReloadButton,
  onReloadClick,
  moderationGroups,
  group,
  onGroupChange,
  teaser,
  onSkipClick,
  isFormValid,
  onModerationClick,
  empty,
  onCampaignChange,
  rejectReasons,
  onReasonChange,
  campaignInfo,
  campaignInfoLoading,
  loading,
  onFormChange,
  errors,
  spellChecker
}) => {
  return (
    <div className="teaser-moderation">
      {showRefreshButton && (
        <div className="content-body moderation-refresh-wrapper">
          <RefreshButton onClick={onRefreshClick}>
            Появились новые анонсы, обновить?
          </RefreshButton>
        </div>
      )}

      {showReloadButton && (
        <div className="teaser-moderation__teaser-refresh">
          <RefreshButton onClick={onReloadClick}>
            Данные были обновлен. Обновить содержание?
          </RefreshButton>
        </div>
      )}

      <FixedHeader className="teaser-moderation__header">
        <PrimaryHeader>
          <span className="header__title">Модерация анонсов</span>
          <ButtonGroup
            items={moderationGroups}
            theme="dark"
            selected={group}
            onClick={onGroupChange}
          />

          {teaser != null && (
            <React.Fragment>
              <span className="teaser-moderation__info">ID: {teaser.id}</span>

              {teaser.user && (
                <span className="teaser-moderation__info">
                  Автор: {teaser.user.name || teaser.user.id}
                </span>
              )}

              <span className="teaser-moderation__info">
                Добавили: {formatDate(teaser.add_date)}
              </span>

              <span
                className="teaser-moderation__skip-btn"
                onClick={onSkipClick}
              >
                Пропустить
              </span>

              {teaser.reject_reasons.length != 0 ? (
                <Button
                  className="teaser-moderation__create-btn"
                  color="red"
                  disabled={!isFormValid || showReloadButton}
                  onClick={onModerationClick}
                >
                  Отклонить
                </Button>
              ) : (
                <Button
                  className="teaser-moderation__create-btn"
                  color="green"
                  disabled={!isFormValid}
                  onClick={onModerationClick}
                >
                  Проверить
                </Button>
              )}
            </React.Fragment>
          )}
        </PrimaryHeader>
        {!empty && teaser != null && (
          <SecondaryHeader>
            <div className="teaser-moderation__controls">
              <CampaignsSelect
                placeholder="Кампания"
                className="campaign"
                value={teaser.cid}
                onSelect={onCampaignChange}
              />
              <ModerRejectReason
                selectedReasons={teaser.reject_reasons}
                reasons={rejectReasons}
                onChange={onReasonChange}
              />
              <CampaignOverview
                info={campaignInfo}
                loading={campaignInfoLoading}
              />
            </div>
          </SecondaryHeader>
        )}
      </FixedHeader>
      <div className="content-body content-body__with-fixed-secondary">
        {loading ? (
          <div className="teaser-moderation__loader">
            <Loader />
          </div>
        ) : empty ? (
          <div className="teaser-moderation__refresh">
            <FormMessage
              color="green"
              className="teaser-moderation__has-new-message"
            >
              На данный момент нет анонсов для проверки.
            </FormMessage>
          </div>
        ) : (
          <TeaserForm
            fields={teaser || {}}
            onChange={onFormChange}
            errors={errors}
            campaignInfo={campaignInfo}
            spellChecker={spellChecker}
          />
        )}
      </div>
    </div>
  );
};

export default TeaserModerationView;
